(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-payment-footer.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-payment-footer.js');

'use strict';

svs.maltipset.views.BetslipPaymentFooter = Marionette.View.extend({
  ui: {
    payButton: '.js-btn-pay'
  },
  className: 'payment-footer',
  modelEvents: {
    change: 'render'
  },
  events: {
    'click @ui.payButton': 'onPayClick'
  },
  log: new svs.core.log.Logger('svs.maltipset.views.BetslipPaymentFooter'),
  template(data) {
    return svs.maltipset.templates.betslip_payment_footer(data);
  },
  initialize() {
    const currentDraw = this.getCurrentDraw();
    this.drawNumber = currentDraw.get('drawNumber');
    this.productId = currentDraw.get('productId');
    this.onPay = this.onPay.bind(this);
  },
  getCurrentDraw() {
    return svs.maltipset.collections.draws.models[svs.maltipset.collections.draws.currentDrawIndex];
  },
  onPay() {
    window.requestIdleCallback(() => {
      this.model.pay();
    });
  },
  onPayClick() {
    this.onPay();
  }
});

 })(window);